import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  animations: [
    trigger('enterTrigger', [
      state('fadeIn', style({
      })),
      transition(':enter', [ animate('500ms')])
    ])
  ],
})
export class LoginPageComponent implements OnInit {
  loginForm!: FormGroup;
  loginSwitch: boolean = false;
  isRegisterOtp: boolean = false;
  isLoginOtp: boolean = false;
  isLogin: boolean = true;
  isLoading = false;

  constructor(public apiService: ApiService, private storage: StorageService, public router: Router, public authService: AuthService, private fb: FormBuilder) {
    this.apiService.isRegisterOtp.subscribe((data) => {
      this.isRegisterOtp = data;
    });
    this.apiService.isLoginOtp.subscribe((data) => {
      this.isLoginOtp = data;
    });
    this.apiService.isLogin.subscribe((data) => {
      this.isLogin = data;
    });

  };

  ngOnInit() {
    this.loginForm = this.fb.group({
      // Define your form controls here
      name: [''],
      password: [''],
    });

  }

}
